<template>
        <div class="user-detail">
             <el-row >
                 <el-col :md="12">
                     職稱: {{ this.userInfo.role == 1 ? '業務' : '美容師'}}
                 </el-col>
                 <el-col :md="12"></el-col>
             </el-row>
             <el-row >
                 <el-col :md="12">
                     帳號: {{userInfo.user_id}}
                 </el-col>
                 <el-col :md="12">
                     密碼: <i  class="el-icon-warning"></i>
                 </el-col>
             </el-row>
             <el-row >
                 <el-col :md="12">
                     姓名: {{userInfo.name}}
                 </el-col>
                 <el-col :md="12">
                     生日: {{userInfo.birthday}}
                 </el-col>
             </el-row>
            
             <el-row>
                 <el-col :md="12">
                     地址: {{userInfo.city}}{{userInfo.area}}{{userInfo.address}}
                 </el-col>
                 <el-col :md="12">
                     電話: {{userInfo.phone}}
                 </el-col>
             </el-row>
             <el-row>
                 <el-col :md="12">
                     店櫃: 
                     <ul v-for="shop in shops" :key="shop._key">
                         <li style="background: rgb(165, 222, 228); width:30%;">{{shop.name}}</li>
                     </ul>
                 </el-col>
                 <el-col :md="12"
                 ></el-col>
             </el-row>
             <el-row>
                 <el-col :md="12">
                     <el-button type="primary" @click="changeEdit">編輯</el-button>
                     <el-button type="default" @click="backSearch">返回</el-button>
                 </el-col>
                 <el-col :md="12"></el-col>
             </el-row>
   </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'Detail',
        props:{
            userKey: String
        },
        data() {
            return {
                role: '',
            userInfo: [],
            shops: [],
            shopName: []
        }
        },
        computed: mapGetters(['UserInfo', 'UserShops']),
        methods: {
            ...mapActions(['fetchUserInfo']),
            
            getUserInfo: function () {
                const data = {_key: this.userKey}
                this.$store.dispatch('fetchUserInfo', data)
              .then(() => {
                  this.userInfo = this.UserInfo
                  this.shops = this.UserShops
                  
              }).catch((err) => {
                  console.log(err)
              });
                
            },
            changeEdit: function(){
                this.$emit('editTabs',  this.userKey)
            },
            backSearch: function(){
                this.$emit('back')
            }
        },
        mounted() {
                   this.getUserInfo()
        },
       
    }
</script>

<style  scoped>
    .user-detail {
        margin: 0 auto;
        padding: 0;
       
        max-height: 100vh;
        
    }
    .el-row {
        margin: 2%;
    }
  
</style>